import React, { Component } from 'react'
import { Grid, Content } from '../components/Layout'
import Sidebar from '../components/Sidebar'
import styled from 'styled-components'
import Header from '../components/Header'

const ContentNotPermission = styled(Content)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  h2,
  h5 {
    padding: 0;
    margin: 0.3em 0;
  }
  h5 {
    color: #999;
  }
`

export default class NotPermission extends Component {
  render() {
    const { menuItems = [], router } = this.props

    return (
      <Grid>
        <Header router={router} />
        <Sidebar menuItems={menuItems} router={router} />
        <ContentNotPermission>
          <div>
            <h2>Você não tem permissão para acessar este conteúdo</h2>
            <h5>Por favor, entre em contato com o administrador do sistema.</h5> <br />
          </div>
        </ContentNotPermission>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/NotPermission.js